/**
 * Bi-directional sticky sidebar for product page.
 * The shorter column is sticky and follows scroll direction (bottom-aligned going down, top-aligned going up).
 */
(function () {
  var galleryCol = document.querySelector('.product-gallery-column');
  var infoCol = document.querySelector('.product-info-column');
  if (!galleryCol || !infoCol || window.matchMedia('(max-width: 749px)').matches) return;

  // Measure actual content, not the stretched flex child
  var galleryContent = galleryCol.querySelector('product-gallery-component') || galleryCol.firstElementChild;
  var infoContent = infoCol.querySelector('.product-info');

  var lastScrollY = window.scrollY;
  var stickyCol = null;
  var currentTop = 0;

  function getHeaderH() {
    return parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '64',
      10
    );
  }

  function getGalleryContentH() {
    return galleryContent ? galleryContent.offsetHeight : galleryCol.scrollHeight;
  }

  function getInfoContentH() {
    return infoContent ? infoContent.offsetHeight : infoCol.scrollHeight;
  }

  function determineStickyCol() {
    // Reset both
    galleryCol.style.position = '';
    galleryCol.style.top = '';
    galleryCol.style.alignSelf = '';
    infoCol.style.position = '';
    infoCol.style.top = '';
    infoCol.style.alignSelf = '';

    var galleryH = getGalleryContentH();
    var infoH = getInfoContentH();

    if (galleryH <= infoH) {
      stickyCol = galleryCol;
    } else {
      stickyCol = infoCol;
    }

    // align-self: flex-start prevents flex stretch so sticky works
    stickyCol.style.alignSelf = 'flex-start';
    stickyCol.style.position = 'sticky';
    currentTop = getHeaderH();
    stickyCol.style.top = currentTop + 'px';
  }

  function getStickyContentH() {
    if (stickyCol === infoCol) return getInfoContentH();
    return getGalleryContentH();
  }

  function onScroll() {
    if (!stickyCol) return;
    var scrollY = window.scrollY;
    var dy = scrollY - lastScrollY;
    lastScrollY = scrollY;
    if (dy === 0) return;

    var headerH = getHeaderH();
    var viewportH = window.innerHeight;
    var contentH = getStickyContentH();

    if (contentH <= viewportH - headerH) {
      currentTop = headerH;
      stickyCol.style.top = currentTop + 'px';
      return;
    }

    var topBound = headerH;
    var bottomBound = viewportH - contentH;
    var rect = stickyCol.getBoundingClientRect();

    if (Math.abs(rect.top - currentTop) < 2) {
      currentTop = Math.max(bottomBound, Math.min(topBound, currentTop - dy));
      stickyCol.style.top = currentTop + 'px';
    }
  }

  determineStickyCol();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', determineStickyCol);

  // Recalc when content height changes (accordion, etc.)
  var observer = new MutationObserver(function () {
    requestAnimationFrame(function () {
      var prevSticky = stickyCol;
      determineStickyCol();

      if (stickyCol === prevSticky) {
        var headerH = getHeaderH();
        var viewportH = window.innerHeight;
        var contentH = getStickyContentH();
        if (contentH <= viewportH - headerH) {
          currentTop = headerH;
        } else {
          var bottomBound = viewportH - contentH;
          currentTop = Math.max(bottomBound, Math.min(headerH, currentTop));
        }
        stickyCol.style.top = currentTop + 'px';
      }
    });
  });

  observer.observe(galleryCol, { childList: true, subtree: true, attributes: true });
  observer.observe(infoCol, { childList: true, subtree: true, attributes: true });
})();
